(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/settings/your-organization', {
      templateUrl: 'modules/app/settings/your-organization/your-organization.html',
      controller: 'YourOrganizationCtrl',
      reloadOnSearch: false,
      requiredPermissions: ['admin', 'manager']
    });
  }]).controller('YourOrganizationCtrl', ['$http', '$location', '$q', '$routeParams', '$scope', '$timeout', '$uibModal', 'Alerts', 'Api', 'User', 'UserRoles', 'Utils', function ($http, $location, $q, $routeParams, $scope, $timeout, $uibModal, Alerts, Api, User, UserRoles, Utils) {
    $scope.$emit("headline:change", "Settings");
    $scope.$emit("nav:change", "settings");

    //define select function for ws-people-groups-search directive
    $scope.select = function (selectedItem) {
      if (selectedItem.personas) {
        $location.path("/settings/people/" + selectedItem.id);
      } else {
        $location.path("/settings/groups/" + selectedItem.id);
      }
    };
    $scope.hasData = null;
    var user = User.get();
    $scope.organizationName = user.organization.name;
    $scope.isAdmin = UserRoles.isOrgAdmin(user) || UserRoles.isSystemAdmin(user);
    $scope.section = "your-organization";
    $scope.sortableOptions = {};
    var requests = [$http.get(Api.url("/group-types"), {
      params: {
        _limit: 150
      }
    }), $http.get(Api.url("/groups"), {
      params: {
        type: "",
        "_limit": 1,
        "sparse": true
      }
    })];
    $q.all(requests).then(function (responses) {
      var emptyGroupTypeName = "Group";
      $scope.groupTypes = _.sortBy(_.filter(responses[0].data.results, function (g) {
        return g.id >= 0;
      }), function (g) {
        return g.displayOrder || g.name;
      });
      //create additional tab if there are groups with no Group Type, with new property emptyType = true
      if (responses[1].data.results.length > 0) {
        $scope.emptyGroupType = {
          "name": emptyGroupTypeName,
          "emptyType": true
        };
      }

      //determine which tab should be active (adding 'tab' to our hardcoded groups, in case org uses same group names)
      angular.forEach($scope.groupTypes, function (groupType) {
        if ($scope.activeTab === Utils.toCamelCase(groupType.name)) {
          $scope.activeTabName = groupType.name;
        }
      });
      var unregisterListener;
      function registerListener() {
        unregisterListener = $scope.$watch('groupTypes', groupTypesListener, true);
      }
      function groupTypesListener(newValue, oldValue) {
        if (angular.equals(newValue, oldValue)) {
          return;
        }
        unregisterListener();
        _.each($scope.groupTypes, function (g, i) {
          g.displayOrder = i;
        });
        $http.put(Api.url("/group-types"), {
          count: $scope.groupTypes.length,
          results: $scope.groupTypes
        }).then(function () {
          Alerts.raiseAlert({
            "type": "success",
            "text": "Changes saved."
          });
          registerListener();
        });
      }
      registerListener();

      // check for exploreModal on url
      if ($location.search().hasOwnProperty('explore')) {
        $scope.exploreYourOrganizationModal();
      }
    });
    $scope.exploreYourOrganizationModal = function () {
      $location.search('explore', true);
      $timeout(function () {
        // timeout to ensure $location has time to update the browser URL
        $uibModal.open({
          templateUrl: 'modules/app/settings/your-organization/modals/explore-your-organization-modal.html',
          controller: 'ExploreYourOrganizationCtrl',
          backdrop: 'static',
          size: 'auto',
          // 'auto' will resize the modal width to window size (minus margins)
          scope: $scope
        });
      }, 100);
    };
  }]).controller('PersonGroupSettingsCtrl', ['$controller', '$filter', '$http', '$q', '$routeParams', '$scope', '$uibModal', 'Api', 'QueryES', 'TinCanJS', 'User', 'UserRoles', '$location', 'Alerts', 'Person', 'Logger', 'Utils', function ($controller, $filter, $http, $q, $routeParams, $scope, $uibModal, Api, QueryES, TinCanJS, User, UserRoles, $location, Alerts, Person, Logger, Utils) {
    $controller('YourOrganizationCtrl', {
      $scope: $scope
    });
    var api,
      args = {};
    if ($scope.personId) {
      api = Api.url("/people/reports/people-with-memberships/" + $scope.personId);
      args = {
        params: {
          parentDepth: -1,
          sparse: true
        }
      };
    } else {
      api = Api.url("/groups/" + $scope.groupId);
      args = {
        params: {
          parentDepth: -1,
          childDepth: 1,
          includePeopleIds: false,
          sparse: false
        }
      };
    }
    var user = User.get();
    $scope.sortedGroupTypes = null;
    $scope.sortedChildGroupTypes = null;
    $scope.editMode = false;
    var getGroupId = function getGroupId(group) {
      return group.id;
    };
    function getParentGroupsByType(rootGroup) {
      return getGroupsByType(rootGroup, "parentGroups");
    }
    function getChildGroupsByType(rootGroup) {
      return getGroupsByType(rootGroup, "childGroups");
    }
    function getGroupsByType(group, groupsField) {
      var stack = _.clone(group[groupsField]);
      if (!stack) {
        return;
      }
      var groupsByType = {};
      var _loop = function _loop() {
        var group = stack.shift();
        var typeName = Utils._try(function () {
          return group.type.name;
        }, "Group");
        var typeDisplayOrder = Utils._try(function () {
          return group.type.displayOrder;
        }, 0);
        var groupsAlreadyAdded = groupsByType[typeName] || [];
        var allGroups = groupsAlreadyAdded.groups ? groupsAlreadyAdded.groups.concat([group]) : groupsAlreadyAdded.concat([group]);
        var uniqueGroups = _.uniq(allGroups, getGroupId);
        groupsByType[typeName] = {
          name: typeName,
          displayOrder: typeDisplayOrder,
          groups: uniqueGroups
        };
        var hasMoreGroupsToProcess = group[groupsField] && group[groupsField].length;
        if (hasMoreGroupsToProcess) {
          stack = stack.concat(group[groupsField]);
        }
      };
      while (stack.length) {
        _loop();
      }
      return Object.keys(groupsByType).map(function (key) {
        return groupsByType[key];
      });
    }
    var getGroups = function getGroups() {
      $http.get(api, args).then(function (response) {
        $scope.entity = response.data;
        $scope.groupsByType = getParentGroupsByType($scope.entity);
        $scope.childGroupsByType = getChildGroupsByType($scope.entity);
        $scope.canEdit = UserRoles.isOrgAdmin(user);
        $scope.availableEmailAddresses = _.compact(_.map($scope.entity.personas, function (p) {
          return p.mbox ? p.mbox.replace("mailto:", "") : undefined;
        }));
        $scope.entity.isAdmin = $scope.entity.membership && $scope.entity.membership.role === 'admin';

        // sort personas for display
        $scope.entity.personas = _.flatten(_.toArray(_.groupBy(_.sortBy($scope.entity.personas, function (p) {
          return $filter('personaDisplay')(p);
        }), function (p) {
          return p.account ? 1 : p.mbox ? 2 : 3;
        })));
        return $scope.entity;
      }, function (err) {
        // If failed for permissions reasons we'll want to  simply hide the area
        $scope.groupsByType = [];
        $scope.childGroupsByType = [];
        $scope.hideParentGroups = true;
        $scope.hideChildGroups = true;
        if (err.status === 404) {
          $location.path("/settings/your-organization");
        } else if (err.status === 403) {
          // 403 Forbidden, likely only seen when Area Admins are viewing people.  They can see
          // the groups the person is in, but can't drill down unless they have permissions. This
          // is a non-issue for global admins of course.
          Alerts.raiseAlert({
            "type": "warning",
            "text": "You do not have permission to view the selected group details."
          });
          history.back();
        }
      }).then(function () {
        var personIds = $scope.personId ? [parseInt($scope.personId)] : null,
          groupIds = $scope.groupId ? [parseInt($scope.groupId)] : null,
          interactionsParams = {
            config: {
              filter: {
                personIds: personIds,
                groupIds: groupIds
              }
            }
          };
        return $http.get(Api.url("/interactions/preview"), {
          params: interactionsParams
        });
      }).then(function (response) {
        $scope.dataLoaded = false;
        $scope.totalStatementCount = response.data.totalHits;
        var statements = response.data.results[0].result;
        $scope.statements = TinCanJS.getDecoratedStatements(statements);
        $scope.statements = $scope.statements.slice(0, 10);
        $scope.dataLoaded = true;
        $scope.hasData = statements.length > 0;
      });
    };
    getGroups();
    $scope.toggleEditMode = function () {
      $scope.editMode = !$scope.editMode;
    };
    $scope.removeFromGroup = function (group) {
      $scope.entity.parentGroupIds = $scope.entity.parentGroupIds.filter(function (id) {
        return id !== group.id;
      });
      $scope.entity.parentGroupCustomIds = $scope.entity.parentGroupCustomIds.filter(function (cid) {
        return cid !== group.customId;
      });
      Person.save($scope.entity).then(getGroups, function removeFromGroupFailure(response) {
        $scope.entity.parentGroupIds.push(group.id);
        Logger.error("Error removing from group, response status " + response.status);
        Alerts.raiseAlert({
          "type": "danger",
          "text": "There was an error removing the person from group: " + response.data.message
        });
      });
    };
  }]);
})();
